module.exports = ".chosen-search {\n    display: none;\n}\nspan {\n    display: block;\n    line-height: 2.5;\n    float: left;\n    padding: 0 10px;\n    margin: 0 0 20px;\n}\n.days {\n    width: 220px;\n}\n.weekdays {\n    width: 270px;\n}\n.minutes {\n    width: 190px;\n}\n.hours, .months {\n    width: 170px;\n}\n.hidden {\n    display: none;\n}\n.interval-message {\n    line-height: normal;\n    margin: 0;\n    padding: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/interval/interval.component.css
// module id = ./src/app/shared/components/interval/interval.component.css
// module chunks = main